import { Action } from "./action";


export class EditAction extends Action {

    override execute(val: any, row?: any): void {

        const url = this.component.editPage + "/edit/";

        if (row.noServerCall)
            this.component.getServiceUrl().goToPage(url, val, false);
        else
            this.component.getServiceUrl().goToPage(url + val.id);

    }
}
